import Icon from "@ant-design/icons";
import { type FunctionComponent } from "react";

import { cn } from "@btnet/utilities-core";

import SVG from "images/Close.svg?react";

import "./BTIconCloseOutlined.less";

import { type IBTIconProps } from "../BTIcon.types";
import { useBaseIcon } from "../BTIcon.utilities";

interface IBTIconCloseOutlinedProps extends IBTIconProps {
    isOnDark?: boolean;
    /**
     * Pass false to use this icon without baked in colors. Default is true
     */
    isDefaultColoring?: boolean;
}

export const BTIconCloseOutlined: FunctionComponent<IBTIconCloseOutlinedProps> = (baseProps) => {
    const { isOnDark, isDefaultColoring = true, ...iconProps } = baseProps;
    const [props] = useBaseIcon(iconProps);

    return (
        // eslint-disable-next-line react/forbid-elements
        <Icon
            {...props}
            component={SVG}
            className={cn({ BTIconCloseOutlined: isDefaultColoring, isOnDark }, props.className)}
        />
    );
};
